import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CoreService } from 'src/app/services/core.service';

@Component({
  selector: 'app-branding',
  standalone: true,
  imports: [RouterModule],
  template: `
    <div class="branding d-flex align-items-center">
      <a [routerLink]="['/']" class="logo-link">
        @if (options.theme === 'light') {
          <div class="logos">
            <img
              src="./assets/images/logos/logo-remitcircle.svg"
              class="align-middle logo-icon"
              alt="RemitCircle Logo"
            />
            @if (logoSrc) {
              <img
                src="./assets/images/logos/text-remitcircle.svg"
                alt="RemitCircle Logo"
              />
            }
          </div>
        } @else {
          <img
            src="./assets/images/logos/light-logo.svg"
            class="align-middle logo-image"
            alt="RemitCircle Logo"
          />
        }
      </a>
    </div>
  `,
  styles: [
    `
      .branding {
        height: 100%;
        padding: 12px 16px;

        .logo-link {
          display: flex;
          align-items: center;
          text-decoration: none;

          .logo-image {
            transition: all 0.3s ease;
            max-height: 32px;
            width: auto;
          }
        }
      }
    `,
  ],
})
export class BrandingComponent {
  options = this.settings.getOptions();

  constructor(private settings: CoreService) {}

  get sidenavCollapsed(): boolean {
    return this.settings.getOptions().sidenavCollapsed;
  }

  get logoSrc(): string {
    return this.options.sidenavCollapsed
      ? ''
      : './assets/images/logos/text-remitcircle.svg';
  }

  get logoAlt(): string {
    return this.options.sidenavCollapsed
      ? 'RemitCircle Icon'
      : 'RemitCircle Logo';
  }
}
